import * as Mod1 from "./discourse/api-initializers/intitialize-whos-online-indicators";
import * as Mod2 from "./discourse/components/whos-online-avatar";
import * as Mod3 from "./discourse/components/whos-online";
import * as Mod4 from "./discourse/connectors/discovery-list-container-top/online_users_widget.gjs";
import * as Mod5 from "./discourse/services/whos-online";
const compatModules = {
  "discourse/api-initializers/intitialize-whos-online-indicators": Mod1,
  "discourse/components/whos-online-avatar": Mod2,
  "discourse/components/whos-online": Mod3,
  "discourse/connectors/discovery-list-container-top/online_users_widget": Mod4,
  "discourse/services/whos-online": Mod5,
};
export { compatModules };
export default compatModules;
